import $ from 'jquery';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
//import 'swiper/css/pagination';

// init Swiper:
new Swiper('.teachersCarousel .swiper', {
    modules: [Navigation, Pagination],
    loop: false,
    createElements: true,
    slidesPerView: 1,
    spaceBetween: 10,
    breakpoints: {
        720: {
            slidesPerView: 2,
            spaceBetween: 20
        },
        960: {
            slidesPerView: 3,
            spaceBetween: 30
        },
        1260: {
            slidesPerView: 4,
            spaceBetween: 40
        }
    },
    pagination: true,
    navigation: {
        enabled: true,
        addIcons: false
    }
});


$('.productsCarousel').each(function (index, element) {

})


new Swiper('.productsCarousel .swiper', {
    modules: [Navigation, Pagination],
    loop: false,
    slidesPerView: 1,
    spaceBetween: 10,
    breakpoints: {
        960: {
            slidesPerView: 2,
            spaceBetween: 30
        },
        1260: {
            slidesPerView: 3,
            spaceBetween: 50
        }
    },
    //pagination: true,
    navigation: {
        enabled: true,
        addIcons: false
    }
});